import { Route } from 'vue-router/types/router';

/**
 * 服务内容类型枚举
 * @property {number} EditableCourseWare - 自主制作
 */
export enum ServiceContentEnum {
  // 1.人工校对
  /** 课件自助制作 */
  EditableCourseWare = 0,

  /** 内容数字化 */
  QuestionBank = 5,

  /** PDF/图片转Word - PDF => 9, 图片 => 2 */
  PdfToDocx = 9,
  ImgToDocx = 2,

  /** 方正书版转Word */
  FbdToWord = 3,

  // 2.机器识别
  /** PDF/图片识别 - PDF => 24, 图片 =>  */
  PdfToDocxTool = 24,
  ImgToDocxTool = 4,

  /** Word转方正 */
  WordToFbd_auto = 16,

  /** 学转教 */
  StudentToTeacher = 10,

  /** Word转PPT */
  WordToPpt = 18,

  /** PPT转希沃 */
  PptToEnbx = 25,

  // ai编辑
  AiEdit = 30,

  // ai校对
  AiCheck = 31,

  // JSON转PPT
  JsonToPpt = 19,
}

export interface IService {
  name: string
  desc: string
  img: string
  show: boolean
  mapKey: string
  to?: string | Route
  service_content: ServiceContentEnum
  usePoints?: boolean
}

interface ILayoutServiceList {
  name: string
  list: IService[]
}

export const serviceList: ILayoutServiceList[] = [
  {
    name: '课件服务',
    list: [
      {
        name: '课件自助下单',
        desc: '自助制作课件，支持输出PPT及Word文件',
        img: require('../assets/service_icons/icon_ppt_v1.png'),
        show: true,
        mapKey: 'editableCourseWare',
        service_content: ServiceContentEnum.EditableCourseWare,
        usePoints: false,
      },
    ],
  },
  {
    name: '数字化服务',
    list: [
      {
        name: '内容数字化下单',
        desc: 'Word、方正、PDF及图片格式进行题库等数字化建设',
        img: require('../assets/service_icons/icon_src2json.png'),
        show: true,
        mapKey: 'questionBank',
        service_content: ServiceContentEnum.QuestionBank,
        usePoints: false,
      },
    ],
  },
  {
    name: '人工校对服务',
    list: [
      {
        name: 'PDF/图片转Word',
        desc: 'PDF及图片文件经过人工校对输出Word文档',
        img: require('../assets/service_icons/icon_img2word.png'),
        show: true,
        mapKey: 'pdfImgToDocx',
        service_content: ServiceContentEnum.PdfToDocx,
        usePoints: false,
      },
      // {
      //   name: 'PDF/图片转Word',
      //   desc: 'PDF及图片文件经过人工校对输出Word文档',
      //   img: require('../assets/service_icons/icon_img2word.png'),
      //   show: false,
      //   mapKey: 'pdfImgToDocx',
      //   service_content: ServiceContentEnum.ImgToDocx,
      //   usePoints: false
      // },
      {
        name: '方正书版转Word',
        desc: '方正书版项目经过人工校对输出Word文档',
        img: require('../assets/service_icons/icon_fbd2word.png'),
        show: true,
        mapKey: 'fbdToWord',
        service_content: ServiceContentEnum.FbdToWord,
        usePoints: false,
      },
    ],
  },
]

export const serviceListContent = [0, 5, 9, 2, 3]

export const serviceByToolList: ILayoutServiceList[] = [
  {
    name: '高精度识别',
    list: [
      {
        name: 'PDF/图片识别',
        desc: 'PDF及图片进行高精度识别后输出Word及方正格式文件',
        img: require('../assets/service_icons/icon_img2word.png'),
        show: true,
        mapKey: 'pdfImgToDocxTool',
        service_content: ServiceContentEnum.PdfToDocxTool,
        usePoints: true,
      },
      // {
      //   name: 'PDF/图片识别',
      //   desc: 'PDF及图片进行高精度识别后输出Word及方正格式文件',
      //   img: require('../assets/service_icons/icon_img2word.png'),
      //   show: false,
      //   mapKey: 'pdfImgToDocxTool',
      //   service_content: ServiceContentEnum.ImgToDocxTool,
      //   usePoints: true
      // },
    ],
  },
  {
    name: '排版',
    list: [
      {
        name: 'Word自动预排',
        desc: '自动将Word文件输出为带基础样式的方正文件',
        img: require('../assets/service_icons/icon_word2fbd.png'),
        show: true,
        mapKey: 'wordToFbd_auto',
        service_content: ServiceContentEnum.WordToFbd_auto,
        usePoints: true,
      },
      {
        name: '学用转教用',
        desc: '自动将方正正文及答案文件合并输出教用文件',
        img: require('../assets/service_icons/icon_fbd2fbd.png'),
        show: true,
        mapKey: 'studentToTeacher',
        service_content: ServiceContentEnum.StudentToTeacher,
        usePoints: false,
      },
      {
        name: 'Word转PPT（自动）',
        desc: '基于 AI 完美而迅速地将教育类 WORD 文档转化成教学课件',
        img: require('../assets/service_icons/icon_fbd2fbd.png'),
        show: true,
        mapKey: 'wordToPpt',
        service_content: ServiceContentEnum.WordToPpt,
        usePoints: true,
      },
      {
        name: 'JSON转PPT（自动）',
        desc: '基于 AI 完美而迅速地将教育类 JSON 文档转化成教学课件',
        img: require('../assets/service_icons/icon_fbd2fbd.png'),
        show: true,
        mapKey: 'jsonToPpt',
        service_content: ServiceContentEnum.JsonToPpt,
        usePoints: true,
      },
    ],
  },
  {
    name: '课件格式转化',
    list: [
      {
        name: 'PPT转希沃',
        desc: '自动将*.pptx格式文件转为*.enbx格式（仅支持由合心科技制作的课件）',
        img: require('../assets/service_icons/icon_src2json.png'),
        show: true,
        mapKey: 'pptToEnbx',
        service_content: ServiceContentEnum.PptToEnbx,
        usePoints: true,
      },
    ],
  },
  {
    name: 'AI编辑（解题）',
    list: [
      {
        name: 'AI编辑（解题）',
        desc: 'AI解题功能',
        img: require('../assets/service_icons/icon_img2word.png'),
        show: true,
        mapKey: 'ai_edit',
        service_content: ServiceContentEnum.AiEdit,
        usePoints: true,
      },
      {
        name: 'AI校对',
        desc: 'AI校对功能',
        img: require('../assets/service_icons/icon_img2word.png'),
        show: true,
        mapKey: 'ai_check',
        service_content: ServiceContentEnum.AiCheck,
        usePoints: true,
      },
    ],
  },
]

export const serviceByToolListContent = [10, 16, 24, 25, 18, 30, 31]
